<template>
    <div id="app">
        <router-view v-if="!isShow"></router-view>
        <!-- 防止token伪造做的拦截 -->
        <div v-loading.fullscreen.lock="isShow" v-else></div>
    </div>
</template>
<script>
import { initDynamicRouter } from '@/router';
import { mapMutations, mapState } from 'vuex';
import { authInfo } from '@/serve/user';

export default {
    methods: {
        ...mapMutations({
            LOGOUT: 'user/LOGOUT',
            SET_SHOW: 'user/SET_SHOW',
            SET_INFO: 'user/SET_INFO'
        })
    },
    computed: {
        ...mapState({
            isShow: state => state.user.isShow,
            modalShow: state => state.user.modalShow,
        })
    },
    watch: {
        modalShow(val) {
            if (val) {
                this.$notify({
                    title: '登录已过期',
                    message: '登录已过期，请重新登录',
                    type: 'error',
                    duration: 3000
                })
            }
        }
    },
    metaInfo() {
        return {
        title: "破产云网络会议",
        meta: [
            {
            name: "keyWords",
            content:
                "破产云网络会议 破产云会议 破产云参会平台 破产云线上会议 破产云网络会议 破产云债权人会议 破产云线上债权人会议 破产云网络会议参会平台"
            },
            {
                name: 'description',
                content: '破产云网络会议系统平台通过“互联网+”便捷有效的解决债权人会议的组织签到会议现场秩序维护计票等程序中的问题系统支持债权人灵活分组一键生成表决结果会场签到表决数据区块链存证保障数据的安全'
            }
        ]
        };
    },
    created() {
        let token = sessionStorage.getItem('ms_token');
        token &&
            authInfo()
                .then(res => {
                    this.SET_INFO(res);
                    initDynamicRouter();
                })
                .catch(err => {
                    this.SET_SHOW();
                    if (err.status == 400) {
                        this.$router.replace('/login');
                        this.LOGOUT();
                        return this.$message.error(err.data.message);
                    }
                });
    }
};
</script>
<style lang="scss">
@import './assets/css/main.css';
@import './assets/css/color-dark.css';
@import './assets/css/common.scss';
</style>
